"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const StyledInput = _styledComponents2.default.input.withConfig({
  displayName: "Input__StyledInput",
  componentId: "sc-12g6j71-0"
})(["color:#4a4a4a;height:40px;outline:0px;width:100%;border:1px solid #aab1ae;font-size:16px;border-radius:4px;padding:12px 32px 12px 6px;transition:all 50ms ease-in-out;box-sizing:border-box;&:focus{border-color:", ";color:#000;outline:none;}&::-webkit-input-placeholder{color:#3d414b;}&::-moz-placeholder{color:#3d414b;}&:-ms-input-placeholder{color:#3d414b;}&:-moz-placeholder{color:#3d414b;}"], p => p.error ? p.theme.colors.red : p.theme.colors.ink["600"]);

const Input = (_ref) => {
  let { value, setValue } = _ref,
      props = _objectWithoutProperties(_ref, ["value", "setValue"]);

  return _react2.default.createElement(StyledInput, _extends({}, props, {
    value: value,
    onChange: e => setValue(e.target.value)
  }));
};

Input.propTypes = {
  value: _propTypes2.default.string,
  setValue: _propTypes2.default.func
};

exports.default = Input;